export const NEXUS_ROLES = {
  ADMIN_MANAGER: 'NEXUS_ADMIN_MANAGER',
  ADMIN_ACCOUNT: 'NEXUS_ADMIN_ACCOUNT',
} as const;

export type NexusRole = (typeof NEXUS_ROLES)[keyof typeof NEXUS_ROLES];
